import React, { useState, useRef } from "react";
import "./signed.scss";
import { isMobile } from "react-device-detect";
import LogoGrid from "../../components/library/LogoGrid";
import LogoCarousel from "../../components/library/logoCarousel/LogoCarousel";
import FAQ from "../../components/library/fAQ/FAQ-new";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import ReactModal from "react-modal";

const SignedPage = () => {
  const [modalSrc, setModalSrc] = useState();
  const [iframeSrc, setIframeSrc] = useState();
  const [iframeHeight, setIframeHeight] = useState();
  const showModalIframe = (src, iframeHeight) => {
    setIframeSrc(src);
    setIframeHeight(iframeHeight);
  };

  return (
    <div className="thank-you-page">
      {/* Section 1 */}
      <div className="welcome-container">
        <div className="text-container">
          <h1>תודה שחתמת על המסמך</h1>
          <p>בדקות הקרובות עותק ישלח אליך במייל.</p>

          <p>אנחנו כאן עבורך לכל שאלה נוספת</p>
        </div>
        <div className="icon-container">
          <img
            src="/images/all/circle-with-checkmark.svg"
            alt="circle with checkmark"
          />
        </div>
      </div>
    </div>
  );
};

export default SignedPage;

const arrow = (
  <svg
    width="30"
    height="54"
    viewBox="0 0 30 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29 52.5764L1 26.9355L29 1.29468"
      stroke="#3566F6"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
